import React from "react";
import { Link } from "react-router-dom";
import { CaretLeft, UsersThree, Star, ShieldCheck } from "@phosphor-icons/react";
import StartLeadForm from "../start/StartLeadForm";
import StartMockup from "../start/StartMockup";
import StartShapes from "../start/StartShapes";
import { HERO } from "../../data/startPageContent";
import { FOR_BREADCRUMB } from "../../data/forPageContent";
import "../start/StartHero.css";
import "./ForPage.css";

const TRUST_ICONS = { therapists: UsersThree, rating: Star, moh: ShieldCheck };

/**
 * Dark hero for /for pages — same anatomy as StartHero (copy + form on the
 * right, CSS mockup on the left) plus a breadcrumb row and a profession badge.
 *
 * @param {string}      crumb      — current page label (breadcrumb + schema)
 * @param {string}      overline
 * @param {ReactNode}   title      — H1 content (may contain <em>)
 * @param {string}      sub
 * @param {string|null} badge      — optional profession badge text
 * @param {string|null} emoji      — optional badge emoji
 * @param {string|null} profession — profession key passed to the lead form + mockup
 * @param {object|null} utm
 */
export default function ForHero({ crumb, overline, title, sub, badge = null, emoji = null, profession = null, utm = null }) {
  return (
    <section id="start-hero" className="st-section st-section--hero st-hero st-dark fr-hero" aria-labelledby="st-h1">
      <StartShapes prefix="st-hero" />
      <div className="st-container">
        <nav className="fr-crumb st-rise st-rise--1" aria-label="Breadcrumb">
          <ol itemScope itemType="https://schema.org/BreadcrumbList">
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <Link to="/" itemProp="item">
                <span itemProp="name">{FOR_BREADCRUMB.home}</span>
              </Link>
              <meta itemProp="position" content="1" />
              <CaretLeft size={12} weight="bold" aria-hidden="true" />
            </li>
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" aria-current="page">
              <span itemProp="name">{crumb}</span>
              <meta itemProp="position" content="2" />
            </li>
          </ol>
        </nav>

        <div className="st-hero-grid">
          <div className="st-hero-copy">
            {badge ? (
              <span className="fr-badge st-rise st-rise--1">
                {emoji && <span aria-hidden="true">{emoji}</span>}
                {badge}
              </span>
            ) : null}
            <p className="st-overline st-rise st-rise--1">{overline}</p>
            <h1 id="st-h1" className="st-h1 st-rise st-rise--2">{title}</h1>
            <p className="st-sub st-hero-sub st-rise st-rise--3">{sub}</p>

            <div className="st-hero-form st-rise st-rise--4">
              <StartLeadForm variant="hero" profession={profession} utm={utm} />
            </div>

            <ul className="st-hero-trust st-rise st-rise--5" aria-label="נתוני אמון">
              {HERO.trust.map((t) => {
                const Icon = TRUST_ICONS[t.key] || ShieldCheck;
                return (
                  <li key={t.key}>
                    <Icon size={18} weight={t.key === "rating" ? "fill" : "regular"} />
                    <span>{t.text}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="st-hero-visual st-rise st-rise--3">
            <StartMockup profession={profession} />
          </div>
        </div>
      </div>
    </section>
  );
}
